module.exports = __webpack_public_path__ + "static/img/12.203d1be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/12.gif
// module id = DHDt
// module chunks = 0